function isJson(value) {
    try {
        JSON.parse(value);
        return true;
    }
    catch {
        return false;
    }
}

export { isJson };
